import styles from './HbxAutoInvoice.styles.js';
import useHbxAutoInvoiceHook from './HbxAutoInvoice.hook.js';
import React, { useContext } from 'react';
import InfoPill from '../../../common/InfoPill/InfoPill';
import BaseTable from '../../../common/BaseTable/BaseTable';
import CustomButton from '../../../common/CustomButton/CustomButton';
import Colors from '../../../../constants/Colors';
import DefaultLayout from 'Components/DefaultLayout/DefaultLayout.jsx';
import { AppContext } from 'App.context.js';
import RequestSuscription from '../../../common/RequestSuscription/RequestSuscription.jsx';
import Modal from 'antd/lib/modal/Modal';
import AdviceDisableProduct from '../AdviceDisableProduct/AdviceDisableProduct.jsx';
import hbxConstants from '../hbxConstants.js';

export default function HbxAutoInvoice() {
  const {
    appActions: { translate },
  } = useContext(AppContext);
  const { state, actions } = useHbxAutoInvoiceHook();

  const columns = [
    {
      title: translate('salesChannels.stateCol'),
      key: 'state',
      dataIndex: 'state',
      align: 'center',
      width: '12%',
      render: () => {
        return (
          <div>
            {actions.getStateTextColor() == Colors.greenHotelIntegratedBg ? (
              <InfoPill
                backgroundColor={actions.getStateBackgroundColor()}
                color={actions.getStateTextColor()}
                text={actions.getStateString()}
              />
            ) : (
              <InfoPill
                color={actions.getStateTextColor()}
                backgroundColor={actions.getStateBackgroundColor()}
                text={actions.getStateString()}
              />
            )}
          </div>
        );
      },
    },
    {
      title: translate('salesChannels.hotelCol'),
      dataIndex: 'hotel',
      key: 'hotel',
      align: 'center',
      width: '25%',
      render: (_, row) => {
        return <div style={{ fontWeight: 500 }}>{row.hotel}</div>;
      },
    },
    {
      title: translate('salesChannels.channelCol'),
      key: 'client',
      dataIndex: 'client',
      align: 'center',
      width: '25%',
    },
    {
      title: translate('salesChannels.actionCol'),
      key: 'key',
      dataIndex: 'key',
      align: 'center',
      width: '20%',
      render: () => <div>{renderActionCol(state, actions, translate)}</div>,
    },
  ];

  let description1 = translate('hbxProducts.pmsInvalidMessage.description1')?.split('%s');

  return (
    <DefaultLayout singleBox>
      {state.suscription ? (
        state.pmsNotPermit === null ? (
          <div style={styles.tableContainer}>
            <div style={styles.table}>
              <BaseTable
                columns={columns}
                data={state.dataSource}
                loading={state.isLoading}
                notShowPagination={true}
                localPagination
              />
            </div>
          </div>
        ) : (
          <div style={styles.containerMessage}>
            <div style={styles.header}>
              <span style={styles.icon}>⚠️</span>
              <span style={styles.title}>{translate('hbxProducts.pmsInvalidMessage.title')}</span>
            </div>

            <div style={styles.description}>
              {description1?.[0]}{' '}
              <b style={styles.highlight}>{hbxConstants.PMS_LIST[state.pmsNotPermit]}</b>
              {description1?.[1]} <b style={styles.highlight}>Invoice Automation</b>.
            </div>

            <div style={styles.divider}></div>

            <div style={styles.description}>
              {translate('hbxProducts.pmsInvalidMessage.description2')}
            </div>
            <div style={styles.boxList}>{hbxConstants.AUTOINV_PMS_PERMIT_TEXT}</div>
          </div>
        )
      ) : (
        <RequestSuscription suscription="hbx_invoicing" />
      )}
    </DefaultLayout>
  );
}

function renderActionCol(state, actions, translate) {
  if (state.isActive) {
    return (
      <div>
        <CustomButton
          background={Colors.disabledButton}
          color={'white'}
          text={translate('hbxProducts.disableButton')}
          onClick={() => actions.setAdviceDisableProduct(true)}
        />
        <Modal
          title={translate('hbxProducts.adviceDisableProduct')}
          open={state.AdviceDisableProduct}
          onCancel={() => actions.setAdviceDisableProduct(false)}
          cancelText={translate('hbxProducts.cancel')}
          onOk={() => {
            actions.setAdviceDisableProduct(false);
            actions.changeOTAState(false);
          }}
          okText={translate('hbxProducts.disable')}
          okType={'danger'}
        >
          <AdviceDisableProduct
            setShowModal={actions.setAdviceDisableProduct}
            product="Invoice Automation"
          />
        </Modal>
      </div>
    );
  } else if (!state.isActive) {
    return (
      <CustomButton
        background={Colors.bookingColorCheckinList}
        color={'white'}
        text={translate('hbxProducts.enableButton')}
        onClick={() => actions.changeOTAState(true)}
      />
    );
  } else {
    return null;
  }
}
